import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPersonCount, getIntelligenceDetect, getIntelligenceConfig } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 人员计算算法统计信息
  personCount: {
    data: {},
    query: {}
  },
  // 通用智能检测算法
  intelligenceDetect: {
    data: {},
    query: {}
  },
  // 设备智能检测开关状态
  intelligenceConfig: {
    data: {},
    query: {}
  }
};

// 获取人员计算算法统计信息
export const fetchPersonCount = createAsyncThunk(
  'ys7Intelligence/fetchPersonCount',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getPersonCount(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取人员统计信息失败');
    }
  }
);

// 通用智能检测算法接口
export const fetchIntelligenceDetect = createAsyncThunk(
  'ys7Intelligence/fetchIntelligenceDetect',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getIntelligenceDetect(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取智能检测信息失败');
    }
  }
);

// 获取设备智能检测开关状态
export const fetchIntelligenceConfig = createAsyncThunk(
  'ys7Intelligence/fetchIntelligenceConfig',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getIntelligenceConfig(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取智能检测开关状态失败');
    }
  }
);

const intelligenceSlice = createSlice({
  name: 'ys7Intelligence',
  initialState: defaultState,
  reducers: {
    resetIntelligenceState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchPersonCount
      .addCase(fetchPersonCount.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.personCount.query = action.meta.arg || {};
      })
      .addCase(fetchPersonCount.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.personCount.data = action.payload?.data?.data || action.payload?.data || {};
        state.personCount.query = action.payload?.query || {};
      })
      .addCase(fetchPersonCount.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.personCount.data = {};
      })

      // fetchIntelligenceDetect
      .addCase(fetchIntelligenceDetect.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.intelligenceDetect.query = action.meta.arg || {};
      })
      .addCase(fetchIntelligenceDetect.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.intelligenceDetect.data = action.payload?.data?.data || action.payload?.data || {};
        state.intelligenceDetect.query = action.payload?.query || {};
      })
      .addCase(fetchIntelligenceDetect.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.intelligenceDetect.data = {};
      })

      // fetchIntelligenceConfig
      .addCase(fetchIntelligenceConfig.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.intelligenceConfig.query = action.meta.arg || {};
      })
      .addCase(fetchIntelligenceConfig.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.intelligenceConfig.data = action.payload?.data?.data || action.payload?.data || {};
        state.intelligenceConfig.query = action.payload?.query || {};
      })
      .addCase(fetchIntelligenceConfig.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.intelligenceConfig.data = {};
      });
  }
});

export const { resetIntelligenceState } = intelligenceSlice.actions;
export default intelligenceSlice.reducer;
